"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BannerContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
`;
const SimpleBanner = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    appearance: "alt2",
    paddingLevel: 6
  }, /*#__PURE__*/_react.default.createElement(BannerContainer, null, children));
};
var _default = SimpleBanner;
exports.default = _default;